module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ../~/symbol-observable/index.js
 ** module id = 115
 ** module chunks = 2
 **/